import { useAuth } from './AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({ children, allowedRoles }) {
  const { currentUser, userData, loading } = useAuth();
  const location = useLocation();

  // ✅ While loading OR waiting for userData, show loading
  if (loading || (currentUser && userData === undefined)) {
    return <div>Loading...</div>;
  }

  // ❌ No user? Send to login
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ❌ If userData exists but has no role (or bad role), send to login
  if (
    allowedRoles &&
    (!userData || !userData.role || !allowedRoles.includes(userData.role))
  ) {
    return (
      <Navigate
        to="/login"
        state={{ from: location, error: 'Unauthorized role. Please contact support.' }}
        replace
      />
    );
  }

  // ✅ All good!
  return children;
}

export default ProtectedRoute;
